import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// React 19: ReactDOM.render removed; use createRoot API
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);
root.render(<App />);



// WEBPACK FOOTER //
// ./src/index.js